<template>
  <label class="file-upload">
    <span class="input-group">
      <span class="label">{{ 'fileupload.button' | trans }}</span>
      <input
        ref="input"
        type="file"
        :disabled="disabled"
        v-on:change="dropped($event.target.files)"
        :multiple=multiple
        :accept=accept
      />
      <div class="input form-control">
        <span v-if="filename">{{ filename }}</span>
        <span class="muted" v-else>{{ 'fileupload.placeholder' | trans }}</span>
      </div>
    </span>
  </label>
</template>

<script>
  import {abstractField} from "vue-form-generator";
  import FileUpload from '@/helpers/components/interact/FileUpload';

  export default {
    name: 'field-file',
    mixins: [abstractField],
    components: {FileUpload},
    props: {
      options: {},
    },
    data () {return {
      
    }},
    computed: {
      accept () {
        return this.schema.accept || '*';
      },
      multiple () {
        return this.schema.multiple || false;
      },
      filename () {
        if (this.value && this.value.length) {
          return this.value.item(0).name;
        }
      },
    },
    methods: {
      dropped: function (files) {
        if (files.length) {
          this.value = files;
          //this.$emit('input', files);
          this.$emit('uploaded', files);
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .file-upload {
    display: block;
    position: relative;
    span.input-group {
      input[type="file"] {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: transparent none;
        color: transparent;
        opacity: 0;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/helpers/mixins/form/File.vue